import React, { useState } from 'react';
import Slider from 'react-slick';
import {
    Card,
    CardMedia,
    CardContent,
    Typography,
    Button,
    Box,
    Grid,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
} from '@mui/material';

import happyClientdata from '../data/happyclinets.json';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import '../styles/carousel.css';

import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import StarHalfIcon from '@mui/icons-material/StarHalf';
import CloseIcon from '@mui/icons-material/Close';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import happclinetbg from "../images/happyClientBg.jpg"

const HappyClients = () => {
    const [open, setOpen] = useState(false);
    const [selectedComment, setSelectedComment] = useState('');

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        pauseOnHover: true,
        arrows: false,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 1,
                },
            },
            {
                breakpoint: 1280,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    };

    const handleReadMore = (comment) => {
        setSelectedComment(comment);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectedComment('');
    };

    const rating = (number) => {
        const stars = [];
        const fullStars = Math.floor(number);
        const hasHalfStar = number % 1 >= 0.3 && number % 1 <= 0.7;

        for (let i = 0; i < fullStars; i++) stars.push(<StarIcon key={i} sx={{ color: '#FFD700', fontSize: '18px' }} />);
        if (hasHalfStar) stars.push(<StarHalfIcon key="half" sx={{ color: '#FFD700', fontSize: '18px' }} />);
        while (stars.length < 5) stars.push(<StarBorderIcon key={`empty-${stars.length}`} sx={{ color: '#FFD700', fontSize: '18px' }} />);
        return stars;
    };

    return (
        <Box
            sx={{
                py: 10,
                backgroundImage: `url(${happclinetbg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: 'white',
                boxShadow: 4,
                borderRadius: 2,
            }}
        >
            <Box textAlign="center" mb={5} px={2} >
                <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: 'black' }}>
                    What Our Client Say About Us
                </Typography>
                <Typography variant="body1" maxWidth="md" margin="auto" sx={{ color: 'white'}}>
                    Big Circle Holidays' commitment to quality, reliability, and professionalism is consistently praised by clients who commend the company for exceeding their expectations.
                </Typography>
            </Box>

            <Box sx={{ px: { xs: 2, sm: 4, md: 8 }, overflow: 'hidden' }}>
                <Slider {...settings}>
                    {happyClientdata.map((pkg) => (
                        <Box key={pkg.id} px={1}>
                            <Card
                                sx={{
                                    backgroundColor: '#0b1f40',
                                    color: 'white',
                                    borderRadius: 2,
                                    height: '100%',
                                    position: 'relative',
                                    px: 2,
                                    py: 3,
                                    minHeight: 280,
                                    overflow: 'hidden',
                                    transition: 'all 0.3s ease-in-out',
                                    '&:hover': {
                                        background: 'linear-gradient(145deg, #153e75, #0b1f40)',
                                        boxShadow: '0 10px 40px rgba(255, 215, 0, 0.25)',
                                        transform: 'translateY(-5px) scale(1.03)',
                                    },
                                    '&:before': {
                                        content: '""',
                                        position: 'absolute',
                                        top: '-50%',
                                        left: '-50%',
                                        width: '200%',
                                        height: '200%',
                                        background: 'radial-gradient(circle at center, rgba(255,255,255,0.05) 0%, transparent 70%)',
                                        opacity: 0,
                                        transition: 'opacity 0.4s ease',
                                        zIndex: 0,
                                    },

                                }}
                            >
                                <Grid container spacing={1} alignItems="center" sx={{ mb: 1 }}>
                                    <Grid item>
                                        <CardMedia
                                            component="img"
                                            sx={{ borderRadius: '50%', height: 40, width: 40 }}
                                            image={pkg.img}
                                            alt={pkg.clientName}
                                        />
                                    </Grid>
                                    <Grid item>
                                        <Typography variant="body1" sx={{ fontWeight: 'bold', color: 'white' }}>
                                            {pkg.clientName}
                                        </Typography>
                                    </Grid>
                                </Grid>

                                <Box>{rating(pkg.ratings)}</Box>
                                <Box>{(pkg.location)}</Box>

                                <CardContent sx={{ px: 0 }}>
                                    <Typography
                                        variant="body1"
                                        sx={{
                                            fontFamily: `'Georgia', serif`,
                                            fontSize: '1.1rem',
                                            fontStyle: 'italic',
                                            lineHeight: 1.6,
                                            display: '-webkit-box',
                                            WebkitLineClamp: 4,
                                            WebkitBoxOrient: 'vertical',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            color: 'white',
                                            mt: 1
                                        }}
                                    >
                                        {pkg.comment}
                                    </Typography>

                                    {pkg.comment.length > 200 && (
                                        <Button size="small" onClick={() => handleReadMore(pkg.comment)} sx={{ mt: 1, color: '#FFD700' }}>
                                            Read More
                                        </Button>
                                    )}
                                </CardContent>

                                <FormatQuoteIcon
                                    sx={{ position: 'absolute', top: 16, right: 16, color: 'white', fontSize: 32 }}
                                />
                            </Card>

                        </Box>
                    ))}
                </Slider>
            </Box>

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle>
                    Full Comment
                    <IconButton
                        onClick={handleClose}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="body1">{selectedComment}</Typography>
                </DialogContent>
            </Dialog>
        </Box>
    );
};

export default HappyClients;
